// IFRAME EMBED URLS
export const MAP_CONSTANTS = {
    tempStayShelters: 'https://www.google.co.in/maps/d/viewer?mid=1Bb7-aFko_z2RVe_1feVbSFvTK_ucVHyY',
    districtWiseCovid: 'https://www.google.co.in/maps/d/embed?mid=1x-pGYJcJZZ9Nn3OnRNpXAeU_nPhQs_3i',
    containmentZones: 'https://www.google.co.in/maps/d/viewer?mid=1fQ8qKPew8D_BaKAx7csodmjIMM4TbFeb',
    hungerReliefCenter: 'https://www.google.co.in/maps/d/viewer?mid=1iyesu48igcUWqkPS7J3TKMO_fGSqDvjU',
    reliefAndShelter: 'https://www.google.co.in/maps/d/viewer?mid=10nMvkDqUyO5_FcBhDi2tbQH7ELtw4Io8',
    covidHealthServices: 'https://www.google.co.in/maps/d/viewer?mid=1yxvXy78wkNoYdtKHYDCPu0lcFfgqB0yq',
};

export const EXTERNAL_URLS = {
    governmentOrders: 'http://health.delhigovt.nic.in/wps/wcm/connect/DoIT_Health/health/home/covid19?WCM_Page.ResetAll=TRUE&CACHE=NONE&CONTENTCACHE=NONE&CONNECTORCACHE=NONE&SRV=Page',
    covidHealthServicesPDF: 'https://nctdelhi.blob.core.windows.net/nctdelhi/DelhiCovidHealth.pdf',
    containmentZonesPDF: 'https://nctdelhi.blob.core.windows.net/nctdelhi/DelhiContainmentZones.pdf',
    whatsapp: 'https://wa.me/918800007722',
    youtubeChannel: 'https://www.youtube.com/channel/UC2mHUT1O3q_oIG0QqLqe1Zg',
    lgCMReliefFund: 'https://lgcmrelieffund.delhi.gov.in/Home.aspx',
    delhiHealthBulletin: 'https://nctdelhi.blob.core.windows.net/nctdelhi/Bulletin.pdf'
}

export const routesEnum = {
  '/': {
    title: 'Information',
  },
  '/lockdown-services/': {
    title: 'Lockdown Services',
  },
  '/covid-delhi-data/': {
    title: 'Data',
  },
  '/infographics/': {
    title: 'Infographics',
  },
};
